var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0714 15H0.928574C0.665479 15 0.444789 14.91 0.266503 14.73C0.0882176 14.55 -0.000615834 14.3275 3.21304e-06 14.0625V11.8594C3.21304e-06 11.5469 0.0659316 11.2578 0.197789 10.9922C0.329646 10.7266 0.519074 10.5078 0.766074 10.3359C1.55536 9.74219 2.46474 9.27719 3.49422 8.94094C4.52369 8.60469 5.52562 8.43687 6.5 8.4375C7.475 8.4375 8.47724 8.60531 9.50671 8.94094C10.5362 9.27656 11.4453 9.74156 12.2339 10.3359C12.4815 10.5078 12.6713 10.7266 12.8031 10.9922C12.935 11.2578 13.0006 11.5469 13 11.8594V14.0625C13 14.3281 12.9109 14.5509 12.7326 14.7309C12.5543 14.9109 12.3339 15.0006 12.0714 15ZM6.5 7.5C5.47857 7.5 4.60417 7.13281 3.87679 6.39844C3.14941 5.66406 2.78572 4.78125 2.78572 3.75C2.78572 2.71875 3.14941 1.83594 3.87679 1.10156C4.60417 0.367188 5.47857 0 6.5 0C7.52143 0 8.39583 0.367188 9.12321 1.10156C9.85059 1.83594 10.2143 2.71875 10.2143 3.75C10.2143 4.78125 9.85059 5.66406 9.12321 6.39844C8.39583 7.13281 7.52143 7.5 6.5 7.5Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.2d74eb001aa72a622efc2fbe25a36829.svg";
export { ForwardRef as ReactComponent };